import React, { useState } from "react";
import { Box, Typography, TablePagination } from "@mui/material";
import ApprovalRequestItem from "./approvalRequestItem";
import theme from "@/utils/theme";
import { useGetAlertsByOfficerId } from "@/hooks/useAlerts";
import { useUserStore } from "@/hooks/useUserStore";
import SkeletonLoader from "@/components/SkeletonLoader";
import { TestResultAlert } from "@/domain/alerts.interface";

const ApprovalRequests: React.FC = () => {
  const { userInfo } = useUserStore();
  const officerId = userInfo?._id;

  const [page, setPage] = useState(0);
  const rowsPerPage = 3;

  const { alerts, isLoadingAlerts, isErrorAlerts, refetchAlerts } =
    useGetAlertsByOfficerId(officerId || "");

  const pagedAlerts = alerts?.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage,
  );

  return (
    <Box
      p={3}
      sx={{
        boxShadow: 1,
        borderRadius: 2,
        bgcolor: "background.paper",
        height: "100%",
      }}
    >
      <Box>
        <Typography
          color={theme.palette.textMain.dark2}
          variant="headlineSmall"
        >
          Approval requests
        </Typography>
      </Box>

      {isErrorAlerts && (
        <Box display="flex" justifyContent="center" mt={2}>
          <Typography color="error">Failed to load alerts</Typography>
        </Box>
      )}

      <SkeletonLoader
        skeletonHeight={80}
        skeletonCount={3}
        isLoading={isLoadingAlerts}
      >
        {!isLoadingAlerts && alerts && alerts.length > 0 && (
          <>
            {pagedAlerts?.map((alert: TestResultAlert) => (
              <ApprovalRequestItem
                alert={alert}
                key={alert._id}
                handleMarkAlertAsViewed={() => {}}
                refetchAlerts={refetchAlerts}
              />
            ))}
            <Box
              borderTop={1}
              marginTop={2}
              borderColor={theme.palette.outline.light2}
            >
              <TablePagination
                component="div"
                count={alerts.length}
                page={page}
                rowsPerPage={rowsPerPage}
                rowsPerPageOptions={[]}
                onPageChange={(_e, newPage) => setPage(newPage)}
              />
            </Box>
          </>
        )}
      </SkeletonLoader>

      {!isLoadingAlerts && alerts?.length === 0 && (
        <Box display="flex" justifyContent="center" mt={2}>
          <Typography>No approval requests</Typography>
        </Box>
      )}
    </Box>
  );
};

export default ApprovalRequests;
